import React, {Component} from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {zoomToSpot} from '../../actions/parkingSpots';


class ReservedSpotButton extends Component {

  render() {
    const {spotId} = this.props;

    return (
      <a className="label label-success" onClick={() => { this.props.zoomToSpot(spotId); }}>
        {spotId}
      </a>
    );
  }

}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({zoomToSpot}, dispatch);
};

export default connect(undefined, mapDispatchToProps)(ReservedSpotButton);



// WEBPACK FOOTER //
// ./src/containers/UserInfoDrawer/ReservedSpotButton.js